export default __webpack_public_path__ + "static/media/status.0b194580.png";